import gsap from 'gsap/dist/gsap.min'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.min'
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin.min"
import Swiper from 'swiper/bundle';
import Loader from 'ui/Loader';
import SmoothScroll from 'ui/SmoothScroll';
import Sticky from 'ui/Sticky';
import LoopSlider from 'ui/LoopSlider';
import Slider from 'ui/Slider';
import Parallax from 'ui/Parallax';
import Hero from 'ui/Hero';
import Problem from 'ui/Problem';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.ScrollToPlugin = ScrollToPlugin
window.Swiper = Swiper;

window.addEventListener('DOMContentLoaded', () => {
  new Loader();
  new SmoothScroll();
  new Sticky();
  new LoopSlider();
  new Slider();
  new Parallax();
  new Hero();
  new Problem();
});


